import { Record } from 'immutable';
import { getFlowActionCount, getActionLimitStatus } from 'automation-ui-canvas/utils/actionLimitUtils';
import { AT_ACTION_LIMIT, BELOW_ACTION_LIMIT, OVER_ACTION_LIMIT } from 'automation-ui-canvas/constants/ActionLimitStatuses';
export const LIMIT = 'limit';
export const STATUS = 'status';
export default class ActionLimit extends Record({
  [LIMIT]: Infinity,
  [STATUS]: BELOW_ACTION_LIMIT
}, 'ActionLimit') {
  getLimit() {
    return this.limit;
  }
  getStatus() {
    return this.status;
  }
  getIsAtActionLimit() {
    return this.status === AT_ACTION_LIMIT;
  }
  getIsAtOrOverActionLimit() {
    return this.status !== BELOW_ACTION_LIMIT;
  }
  getIsBelowActionLimit() {
    return this.status === BELOW_ACTION_LIMIT;
  }
  getIsOverActionLimit() {
    return this.status === OVER_ACTION_LIMIT;
  }
  setUpdatedStatus(flow) {
    const actionCount = getFlowActionCount(flow);
    const currentStatus = this.getStatus();
    const newStatus = getActionLimitStatus(this, actionCount);
    if (currentStatus !== newStatus) {
      return this.set(STATUS, newStatus);
    }
    return this;
  }
}